import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=50701db8&scoped=true&"
import script from "./Session.vue?vue&type=script&lang=js&"
export * from "./Session.vue?vue&type=script&lang=js&"
import style0 from "./Session.vue?vue&type=style&index=0&id=50701db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50701db8",
  null
  
)

export default component.exports